import { ExperimentFlag } from '../enums/ExperimentFlag'
import { getRoll, entropyValue } from './random'

/**
 * Used to select experiments in A/B or Multi-variant testing
 */

export class Experiment {
  constructor(readonly allExperiments: Array<IExperiment>) {}

  activate<T>(flag: ExperimentFlag): T | null {
    const experimentSet = this.allExperiments.filter(
      (f) => f && f.flag === flag
    )
    if (!experimentSet.length) {
      return null
    }

    let experiment:
      | INonDefaultExperiment<any>
      | IDefaultExperiment<any>
      | undefined

    for (let n = 0; n < experimentSet.length; n++) {
      if (experimentSet[n].default && experimentSet[n].default === true) {
        experiment = experimentSet[n]
        break
      }
    }

    if (!experiment) {
      throw Error(`No default experiment provided for ${flag}`)
    }

    let currentPercentile = 100 * entropyValue
    const roll = getRoll(currentPercentile)

    for (const f of experimentSet) {
      if (f.default) {
        continue
      }
      currentPercentile -= f.percent * entropyValue
      if (roll > currentPercentile) {
        experiment = f
        break
      }
    }

    const randomRegex = /random\((\d+.?\d*),\s*(\d+.?\d*),?\s*(\d+)\)/
    const matches = randomRegex.exec(experiment.value)
    if (matches) {
      const min = parseFloat(matches[1])
      /* eslint-disable-next-line  */
      const max = parseFloat(matches[2])
      /* eslint-disable-next-line  */
      const precision = parseInt(matches[3], 10)

      // @ts-ignore
      return generateNumberWithPrecision(min, max, precision)
    }

    return experiment.value as T
  }
}

function generateNumberWithPrecision(
  min: number,
  max: number,
  decimalPlaces: number
): number {
  const rand = Math.random() * (max - min) + min
  const power = Math.pow(10, decimalPlaces)

  return Math.floor(rand * power) / power
}

interface IBaseExperiment<T> {
  flag: string
  value: T
}

interface INonDefaultExperiment<T> extends IBaseExperiment<T> {
  percent: number
  default?: never
}

interface IDefaultExperiment<T> extends IBaseExperiment<T> {
  default: true
  percent?: never
}

export type IExperiment<T = any> =
  | INonDefaultExperiment<T>
  | IDefaultExperiment<T>
